import { useEffect, useRef } from 'react'
import { MOMENTE } from './momente.js'
import MomentCap from './MomentCap.jsx'
import { ramp, makeScrubber, showCap } from './scrub.js'

// Scena de final: semnul Vinewood cu elicopterul, după Despre și Gameplay.
// u = cât a urcat scena peste marginea de sus a ecranului (în ecrane): negativ cât încă intră pe ecran.
//   -1 .. 0.1      clipul apare din întuneric și se retrage ușor din zoom, cât scena urcă pe ecran;
//                  un gradient de sus îl topește în fundalul de la Gameplay, ca să nu intre cu o margine tăiată
//   -0.6 .. 0.9    clipul se derulează
//    0.7 .. 0.95   cadrul se întunecă ușor și apare butonul de Discord, sub semn; rămâne până la footer
const FINAL = MOMENTE.findIndex((m) => m.final)

const Final = () => {
    const ref = useRef(null)

    useEffect(() => {
        const sec = ref.current
        const stage = sec.querySelector('.final-stage')
        const v = sec.querySelector('video')
        const cap = sec.querySelector('.moment-cap')
        const shade = sec.querySelector('.moment-shade')
        const sc = makeScrubber([v], [FINAL])
        let raf = 0

        const loop = () => {
            const r = sec.getBoundingClientRect()
            const u = -r.top / window.innerHeight
            // încarcă din timp, cât scena e încă la două ecrane distanță
            if (r.top < window.innerHeight * 2.5) sc.load(0)
            if (r.bottom > 0 && r.top < window.innerHeight) {
                v.style.opacity = ramp(-1, 0.1, u)
                v.style.transform = `scale(${1.06 - 0.06 * ramp(-1, 0.3, u)})`
                stage.style.setProperty('--fin', 1 - ramp(-0.5, 0.15, u))
                sc.seek(0, ramp(-0.6, 0.9, u))
                shade.style.opacity = ramp(0.7, 0.9, u)
                showCap(cap, ramp(0.7, 0.9, u), ramp(0.7, 0.95, u))
            }
            raf = requestAnimationFrame(loop)
        }
        raf = requestAnimationFrame(loop)
        return () => { cancelAnimationFrame(raf); sc.stop() }
    }, [])

    return (
        <section className="cine final-cine" id="final" ref={ref}>
            <div className="stage final-stage">
                <div className="momente">
                    <video className="cine-video" poster={MOMENTE[FINAL].poster} muted playsInline webkit-playsinline="true" preload="none" />
                    <div className="moment-shade"></div>
                    <MomentCap i={FINAL} />
                </div>
            </div>
        </section>
    )
}

export default Final
